var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelxonLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 51,
    viewBox: "0 0 156 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60_539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 25,
    width: 23,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9685 25.9366H41.3735V50.2971H19.9685V25.9366Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3306 26.1795C40.2454 26.0084 41.0313 26.619 41.2151 27.5232C40.9552 31.4949 41.5932 35.9736 41.2299 39.8841C41.1559 40.6869 40.9869 40.9805 40.3214 41.4157L23.1586 50.0394C21.7516 50.707 20.7565 50.0119 20.6234 48.512C20.3615 45.5374 20.3636 39.6812 20.6234 36.7109C20.7312 35.4856 21.1283 35.287 22.1044 34.7462L39.3285 26.1795H39.3306Z",
    fill: "#FA9FAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_60_539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.0501V24.3141H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_60_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8828 0.00849254C19.6687 -0.08235 20.5729 0.52397 20.6194 1.36057C20.3659 5.38087 20.9976 9.90398 20.6384 13.863C20.5729 14.594 20.3173 14.8602 19.73 15.251L2.31782 24.0564C1.04814 24.443 0.0256348 23.6634 0.0256348 22.3388C0.0298597 19.2924 0.11859 16.2017 0.186193 13.1447C0.217883 11.7377 -0.303933 9.62089 1.08194 8.8688L18.8828 0.00849254Z",
    fill: "#0098FD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_60_539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 5,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1318 5.38507H41.3735V24.3141H22.1318V5.38507Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_60_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4764 5.47169C40.3552 5.36817 41.1559 6.05477 41.2277 6.95052L41.2256 22.6261C41.1369 23.7902 40.0743 24.4641 38.9757 24.0247L23.5346 16.2566C22.4593 15.6862 22.2206 14.2285 23.3001 13.5208L39.4743 5.47169H39.4764Z",
    fill: "#FED929"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_60_539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 25,
    width: 19,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.9366H18.8868V44.8656H0V25.9366Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_60_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2932 36.5947L2.28588 44.7283C1.44083 45.0853 0.242981 44.61 0.17749 43.6213L0.259882 27.0182C0.665504 26.2239 1.54224 25.9239 2.36616 26.3253L17.7291 34.03C18.6882 34.5412 18.9755 35.7306 18.2953 36.5968L18.2932 36.5947Z",
    fill: "#6BD4F2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7395 13.6019V36.2322H65.3818V25.7874H51.2189V36.2322H48.8274V13.6019H51.2189V23.6917H65.3818V13.6019H67.7395Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4347 28.4409H75.2126C75.3415 30.2112 76.0196 31.6394 77.2491 32.7252C78.4766 33.8132 80.0293 34.3562 81.9053 34.3562C82.9574 34.3562 83.9271 34.1682 84.8123 33.79C85.6954 33.414 86.4623 32.8583 87.1108 32.1253L88.4038 33.6125C87.6474 34.521 86.7052 35.2097 85.5728 35.6829C84.4405 36.1561 83.194 36.3927 81.8377 36.3927C80.0906 36.3927 78.5442 36.0209 77.1984 35.2773C75.8506 34.5336 74.8006 33.5069 74.0464 32.1929C73.2901 30.8746 72.9141 29.3873 72.9141 27.731C72.9141 26.0705 73.2732 24.5832 73.9957 23.2692C74.7161 21.9509 75.7069 20.9263 76.9703 20.1932C78.2315 19.4622 79.6491 19.0947 81.2209 19.0947C82.7969 19.0947 84.2081 19.4622 85.4545 20.1932C86.7052 20.9263 87.6855 21.9467 88.3953 23.2523C89.1094 24.5536 89.4685 26.0473 89.4685 27.731L89.4347 28.4409ZM81.2209 21.0721C79.5857 21.0721 78.2125 21.596 77.097 22.6438C75.9858 23.6875 75.3584 25.048 75.2126 26.7254H87.2714C87.1193 25.048 86.4876 23.6875 85.3785 22.6438C84.2673 21.596 82.8814 21.0721 81.2209 21.0721Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1565 12.2413H96.4466V36.2322H94.1565V12.2413Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.678 36.2322L108.287 29.1169L102.853 36.2322H100.267L106.994 27.5029L100.588 19.2299H103.174L108.287 25.8888L113.391 19.2299H115.909L109.512 27.5029L116.298 36.2322H113.678Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.449 36.3927C124.814 36.3927 123.339 36.0209 122.021 35.2773C120.707 34.5336 119.674 33.5069 118.919 32.1929C118.163 30.8746 117.787 29.3873 117.787 27.731C117.787 26.0705 118.163 24.5832 118.919 23.2692C119.674 21.9509 120.707 20.9263 122.021 20.1932C123.339 19.4622 124.814 19.0947 126.449 19.0947C128.088 19.0947 129.563 19.4622 130.877 20.1932C132.195 20.9263 133.226 21.9509 133.97 23.2692C134.713 24.5832 135.085 26.0705 135.085 27.731C135.085 29.3873 134.713 30.8746 133.97 32.1929C133.226 33.5069 132.195 34.5336 130.877 35.2773C129.563 36.0209 128.088 36.3927 126.449 36.3927ZM126.449 34.3562C127.659 34.3562 128.743 34.0836 129.702 33.5365C130.659 32.9851 131.405 32.2013 131.942 31.1873C132.482 30.1732 132.753 29.0218 132.753 27.731C132.753 26.436 132.482 25.2846 131.942 24.2748C131.405 23.2607 130.659 22.4791 129.702 21.9256C128.743 21.3742 127.659 21.0974 126.449 21.0974C125.243 21.0974 124.161 21.3742 123.204 21.9256C122.245 22.4791 121.491 23.2607 120.939 24.2748C120.386 25.2846 120.111 26.436 120.111 27.731C120.111 29.0218 120.386 30.1732 120.939 31.1873C121.491 32.2013 122.245 32.9851 123.204 33.5365C124.161 34.0836 125.243 34.3562 126.449 34.3562Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M148.435 19.0947C150.568 19.0947 152.267 19.7158 153.53 20.9538C154.792 22.1939 155.423 24.0001 155.423 26.3705V36.2322H153.125V26.5987C153.125 24.8304 152.681 23.4847 151.798 22.5593C150.913 21.6298 149.652 21.165 148.012 21.165C146.181 21.165 144.729 21.7122 143.66 22.8044C142.595 23.8924 142.063 25.3945 142.063 27.3085V36.2322H139.773V19.2299H141.97V22.365C142.595 21.3298 143.462 20.527 144.573 19.9566C145.682 19.382 146.969 19.0947 148.435 19.0947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelxonLogo);
export default __webpack_public_path__ + "static/media/helxonLogo.852618f3dcb989ae25b59ce3d026657a.svg";
export { ForwardRef as ReactComponent };